import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'

interface SectionProps {
  title: string
  description?: string
  children: React.ReactNode
  divider?: boolean
}

export default function Section({ title, description, children, divider = true }: SectionProps) {
  return (
    <Box sx={{ mb: 5 }}>
      {divider && <Divider sx={{ mb: 4 }} />}
      <Typography variant="h3" sx={{ mb: 1.5 }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {description}
        </Typography>
      )}
      {children}
    </Box>
  )
}

// Sub-section for nested content
interface SubSectionProps {
  title: string
  children: React.ReactNode
}

export function SubSection({ title, children }: SubSectionProps) {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h5" sx={{ mb: 1.5 }}>
        {title}
      </Typography>
      {children}
    </Box>
  )
}
